<template>
  <div class="burger-menu-wrapper">
      <div class="burger-menu-backdrop" @click="$emit('close')"></div>
      <div class="burger-menu-contents">
          <slot>
              <template v-for="(item,index) in items">
                <div class="burger-row" @click="$emit('input', item.value)" :class="{
                    selected: value === item.value
                }" :key="index">
                  <div class="qrw-container-title-sm">
                      {{ item.text_left }}
                  </div>
                  <div class="qrw-container-title-sm">
                      {{ item.text_right }}
                  </div>
              </div>
              <BaseDivider v-if="index != items.length-1" class="row-divider" :key="'divider_'+index"/>
              </template>
              
          </slot>
      </div>
  </div>
</template>

<script>
export default {
    props: {
        items: Array,
        value: [String, Number]
    },
    mounted() {
        this.toggleGlobalScrolling(true);
    },
    beforeDestroy() {
        this.toggleGlobalScrolling(false);
    }
}
</script>

<style scoped>
.burger-menu-wrapper {
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
}

.burger-menu-backdrop {
    position: absolute;
    z-index: 10;
    height: 100%;
    width: 100%;
    background-color: var(--black-10-color);
    opacity: 0.48;
    top: -1px;
}

.burger-menu-contents {
    padding: 24px;
    background-color: var(--black-1-color);
    opacity: 1;
    z-index: 11;
    position: relative;

    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.burger-row {
    display: flex;
    justify-content: space-between;

    color: var(--grey-7-color);
}

.burger-row.selected {
    color: var(--white-10-color);
}

.row-divider {
    border-color: var(--grey-10-color) !important; 
}
</style>